import {Component, inject, OnInit} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../services/auth.service";
import {NotificationService} from "../../services/notification.service";
import {Router} from "@angular/router";
import {Location} from "@angular/common";

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  loading: boolean = false;

  form: FormGroup;
  hide = true;

  private fb: FormBuilder = inject(FormBuilder)
  private authService: AuthService = inject(AuthService)
  private notificationService: NotificationService = inject(NotificationService);
  private router: Router = inject(Router);
  private location: Location = inject(Location)

  ngOnInit() {
    this.form = this.fb.group({
      email: [null, Validators.required],
    });
  }

  submitForm(value){
    if(value.email){
      this.authService.forgotPassword(value).then(
        async () => {
          await this.router.navigate(['auth', 'check-your-email']);
        }
      )
    } else{
      this.notificationService.errorMessage("Please enter a your email address");
    }
  }

  goBack() {
    this.location.back();
  }
}
